import { AddressModel } from './address.model';

export class OrderAddressModel extends AddressModel {
  static ATTR_ORDER_ID = 'order_id';

  static ATTR_TYPE = 'type';

  static ATTR_CUSTOMER_ADDRESS_ID = 'customer_address_id';

  static ATTR_CREATED_AT = 'created_at';

  static ATTR_UPDATED_AT = 'updated_at';

  /**
   * @return {Number}
   */
  get type() {
    return this.attributes[OrderAddressModel.ATTR_TYPE];
  }

  get isBilling() {
    return this.type === 2;
  }

  get isShipping() {
    return this.type === 1;
  }

  get customerAddressId() {
    return this.attributes[OrderAddressModel.ATTR_CUSTOMER_ADDRESS_ID];
  }

  get createdAt() {
    return this.attributes[OrderAddressModel.ATTR_CREATED_AT];
  }
}
